import {
  FETCH_NOTIFICATIONS_FOR_APPUSER,
  SET_SELECTED_NOTIFICATION,
  FETCH_NOTIFICATION_SOCIAL_DETAILS,
  FETCH_UNREAD_NOTIFICATION_COUNT,
  FETCH_NOTIFICATION_COMMUNITY_DETAILS,
  FETCH_NOTIFICATION_CHAT_DETAILS,
  OPEN_OUTREACH_MODAL
} from '../actions';

export const notificationReducer = (state = {}, action) => {
  if (action.type == FETCH_NOTIFICATIONS_FOR_APPUSER) {
    return action.payload;
  }
  return state;
};

export const selectedNotificationReducer = (state = {}, action) => {
  if (action.type == SET_SELECTED_NOTIFICATION) {
    return action.payload;
  }
  return state;
};

export const notifiedSocialPostDetailsReducer = (state = {}, action) => {
  if (action.type == FETCH_NOTIFICATION_SOCIAL_DETAILS) {
    return action.payload;
  }
  return state;
};

export const notifiedCommunityDetailsReducer = (state = {}, action) => {
  if (action.type == FETCH_NOTIFICATION_COMMUNITY_DETAILS) {
    return action.payload;
  }
  return state;
};

export const notificationUnreadCountReducer = (state = {}, action) => {
  if (action.type == FETCH_UNREAD_NOTIFICATION_COUNT) {
    return action.payload;
  }
  return state;
};

export const notifiedChatDetailsReducer = (state = {}, action) => {
  if (action.type == FETCH_NOTIFICATION_CHAT_DETAILS) {
    return action.payload;
  }
  return state;
};

export const outreachModalReducer = (state = { show: false }, action) => {
  if (action.type == OPEN_OUTREACH_MODAL) return action.payload;
  return state;
};
